export default (theme: any) => !theme.name;
